export const frontendURI = '/cat/language/';
export const backendURI = `/api${frontendURI}`;
